
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import coverImg from "../../images/cover_not_found.jpg";
import "./BookDetails.css";
import { useGlobalContext } from '../../context';
import { FaArrowLeft } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from "jwt-decode";
import { Autocomplete } from '@mui/material';
import TextField from '@mui/material/TextField';
import { Helmet } from 'react-helmet-async';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Loader from "../Loader/Loader.jsx";
import { Link } from 'react-router-dom';
import { api } from '../../config.js';
import ReactQuill from 'react-quill';
import { debounce } from 'lodash';
import 'react-quill/dist/quill.snow.css';

const BookDetails = () => {

  const { id } = useParams();
  const [loading, setLoading] = useState(true); // Set loading state to true initially
  const [book, setBook] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [related_books , setRelated_books] = useState([]);
  const [categories, setCategories] = useState([]);
  const [authors, setAuthors] = useState([]);
  //global context
  const {searchCriteria, setSearchTerm,setSearchCriteria,searchText, setSearchText} = useGlobalContext();

  const [formData, setFormData] = useState({
    title: '',
    description: '',
    first_publish_year: '',
    cover_image: '',
    book_url: '',
    type: '',
    category: '',
    author: [],
    related_book: '',
    order: '',
    category_id: '',
  });
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);


  const checkTokenExpiration = () => {
    const token = localStorage.getItem('token');

    if (token) {
      const decodedToken = jwtDecode(token);
      const currentTime = Date.now() / 1000; // Convert milliseconds to seconds

      if (decodedToken.exp < currentTime) {
        // Token has expired, clear it from local storage
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('username');
      }
    }else{
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('username');
    }
    const username = localStorage.getItem('username');
    setIsLoggedIn(!!username);
  };

  const handleBack = () => {


    if (window.history.state && window.history.state.idx > 0) {
      if(searchCriteria.isSearching === true){
        setSearchCriteria(prev => ({
          ...prev,
          location: "main",
          type: "book",
          allFilter:"book",
          isSearching: true,
        }));
        setSearchTerm(searchText);
        // setSearchTextShow(searchText)
      }
      navigate(-1);
    } else {

      navigate('/'); // or whatever your home path is
    }
  };

  const getRelatedBooks = async () => {
    try {
      const response = await fetch(`${api}/book_author/related_books`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          }
        });
       let data = await response.json();
        //console.log(data);
        setRelated_books(data);
      }

     catch (error) {
      //console.log(error);
    }
  }
  const getCategories = async () => {
    try {
        const response = await fetch(`${api}/book_author/category`, { method: 'GET' });
        const data = await response.json();
        setCategories(data);
    } catch (error) {
        console.error('Error fetching categories:', error);
    }
  }
  useEffect(() => {
    checkTokenExpiration();
  }, [checkTokenExpiration]);

  useEffect(() => {
    const username = localStorage.getItem('username');
    setIsLoggedIn(!!username); // Check if username exists in localStorage
    getBookDetails(); // Fetch book details when component mounts
  }, [id]);

  const getBookDetails = async () => {
    const token = localStorage.getItem('token');
    if (!token) {
        // Handle the case when token is null (e.g., redirect to login page)
        //console.log('User is not authenticated. Redirecting to home page...');
        // window.location.href = '/index';
        // Redirect logic or display unauthorized message
        // return;
    }

    try {
      const response = await fetch(`${api}/book_author/book/${id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
 // Include token in request header

        },
      });

      const data = await response.json();
      if(data.error =="Book not found"){

        navigate('/');
      }
      if (data) {
        const newBook = {

          book_id: data.book_id ? data.book_id :null,
          author_ids:data.author_ids,
          description: data.description ? data.description : "",
          title: data.title,
          book_url: data.book_url ? data.book_url : "لايوجد رابط",
          first_publish_year: data.first_publish_year ? data.first_publish_year : "لايوجد بيانات",
          type: data.type ? data.type : "لايوجد نوع",
          category: data.category ? data.category : 0,
          cover_image: data.cover_image ? data.cover_image : coverImg,
          authors: data.authors ? data.authors.split(',').map(author => author.trim()) : ["لايوجد مؤلفين"],
          authors_comp: data.authors,
          visit: data.visit ? data.visit : 0,
          related_books : data.related_books ? data.related_books : "لايوجد أجزاء/ بحوث",
          category_id : data.category_id ? data.category_id : 0,
          order : data.order ? data.order : 0,

        };



        const authorObjects = [];

        // Splitting author IDs and names
        const authorIds = (data.author_ids)?data.author_ids.split(',').map(id => id.trim()):[];
        const authors = (data.authors)?data.authors.split(',').map(name => name.trim()):[];

        // Loop through each author
        for (let i = 0; i < authorIds.length; i++) {
            const authorId = authorIds[i];
            const authorName = authors[i];

            // Create author object
            const author = {
                author_id: [authorId,data.book_id],
                author_name: authorName
            };

            // Push author object to temporary array
            authorObjects.push(author);
        }

        // Set authors in state
        setAuthors(authorObjects);
        let decodedToken ='';
        if (token) {
           decodedToken = (token);
        }
        setBook({...newBook,author:authorObjects});
        setFormData({...formData, author: Array.isArray(data.authors) ? data.authors : [data.authors],token:decodedToken });
      } else {
        setBook(null);
      }
      setLoading(false); // Set loading to false after data is fetched
    } catch (error) {
      //console.log(error);
      setLoading(false); // Set loading to false in case of error
    }
  };

  function isEmptyRichText(value) {
    // Remove HTML tags and trim the remaining text
    const textOnly = value.replace(/<[^>]*>/g, '').trim();
    return textOnly === '';
  }


  function validateForm(formData) {
    let isValid = true;
    const errors = {};

    // التحقق من العنوان
    if (!formData.title.trim()) {
        errors.title = "العنوان مطلوب.";
        isValid = false;
    }

    // التحقق من رابط صورة الغلاف
    if (!formData.cover_image.trim()) {
        // Handle invalid URL format (e.g., display an error message)
        errors.cover_image = "رابط صورة الغلاف مطلوب.";
        isValid = false;
    }else{
      const urlPattern = /^(https?:\/\/)?[\w-]+(\.[\w-]+)+([\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])?$/;
      if (!urlPattern.test(formData.cover_image.trim())) {

        errors.cover_image = "الرجاء التحقق من رابط صورة الغلاف .";
        isValid = false;

      }
    }

    // التحقق من رابط المحتوى (اختياري إذا كان مطلوبًا)

    if (!formData.book_url.trim()) {
      // Handle invalid URL format (e.g., display an error message)
      errors.book_url = "رابط المحتوى مطلوب.";
      isValid = false;
  }else{
    const urlPattern = /^(https?:\/\/)?[\w-]+(\.[\w-]+)+([\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])?$/;
    if (!urlPattern.test(formData.book_url.trim())) {

      errors.book_url = "الرجاء التحقق من رابط المحتوى  .";
      isValid = false;

    }
  }

    // التحقق من وصف باستخدام دالة التحقق من النص الغني


    // التحقق من المؤلف (التحقق من تحديد مؤلف واحد على الأقل)
    if (!formData.author.length) {
        errors.author = "يجب تحديد مؤلف واحد على الأقل.";
        isValid = false;
    }

    // التحقق من سنة النشر
    if (!formData.first_publish_year.trim()) {
        errors.first_publish_year = "سنة النشر مطلوبة.";
        isValid = false;
    }

    // التحقق من النوع
    if (!formData.type.trim()) {
        errors.type = "نوع النشر مطلوب.";
        isValid = false;
    }

    // التحقق من المجلة للمجلات
    if (formData.type === 'journal' && !formData.category) {
        errors.category = "المجلة مطلوبة للاعداد.";
        isValid = false;
    }

    return { isValid, errors };
  }

  // Function to handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    const { isValid, errors } = validateForm(formData);

    if (!isValid) {
      Object.values(errors).forEach(error => {
        toast.error(error, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
    }); // Here you could set these errors to state and display them in the form
        return;
    }

    formData.category = formData.category_id || 0 ;
    if (isEmptyRichText(formData.description)) {
      formData.description = null;
  }
  setLoading(true);

    const token = localStorage.getItem('token');
    if (!token) {
        // Handle the case when token is null (e.g., redirect to login page)
        //console.log('User is not authenticated. Redirecting to home page...');
        setLoading(false);
        window.location.href = '/index';
        // Redirect logic or display unauthorized message
        return;
    }

    let decodedToken ='';
    if (token) {
       decodedToken = (token);
    }
    try {




      const response = await fetch(`${api}/book_author/book/${formData.book_id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${decodedToken}` // Include token in request header

        },
        body: JSON.stringify(formData),
      });
      const data = await response.json();

      if (data.message === "Book updated successfully") {
        //console.log("      <ToastContainer />");
        toast.success('تم التحديث بنجاح');
        // setAuthors(prevAuthors => [...prevAuthors]);

      }else{

      }
      //console.log(data);
      setLoading(false);
    } catch (error) {
      //console.log(error);
      setLoading(false);
    }
    getBookDetails();
    setShowForm(false);
    setLoading(false);

  };

  // Function to handle updating the book
  const handleUpdateBook = () => {
    getRelatedBooks();
    getCategories();

    setFormData(book);

    setShowForm(true);
  };




  const handleChange = (e) => {

    const token = localStorage.getItem('token');
    if (!token) {
        // Handle the case when token is null (e.g., redirect to login page)
        //console.log('User is not authenticated. Redirecting to home page...');
        window.location.href = '/index';
        // Redirect logic or display unauthorized message
        return;
    }
    let decodedToken ='';
    if (token) {
       decodedToken = (token);
    }
    setFormData({ ...formData, [e.target.name]: e.target.value,token:decodedToken });
  };
  const debouncedSetDescription = debounce(value => {
    handleQuillChange(value);
  }, 300);
  const handleQuillChange = (value) => {

    const token = localStorage.getItem('token');
    if (!token) {
        //console.log('User is not authenticated. Redirecting to home page...');
        window.location.href = '/index';
        return;
    }
    let decodedToken = '';
    if (token) {
        decodedToken = (token);
    }
    // Directly use 'description' as the name since that's the only ReactQuill instance
    setFormData({ ...formData, description: value, token: decodedToken });
};

const confirmDelete = () => {

  toast.warn(
  <div>
      هل انت متأكد من الحذف؟

      <button onClick={handleDeleteBook} style={{ marginLeft: '10px', color: 'red', border: 'none', background: 'none', cursor: 'pointer' }}>
       حذف
      </button>
      <button onClick={() => toast.dismiss()} style={{ marginLeft: '10px', color: 'green', border: 'none', background: 'none', cursor: 'pointer' }}>
        تراجع
      </button>
    </div>, {
      position: "top-center",
      autoClose: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: false
    });
};

  const handleDeleteBook = async () => {

    setLoading(true);
    const token = localStorage.getItem('token');
    if (!token) {
        // Handle the case when token is null (e.g., redirect to login page)
        //console.log('User is not authenticated. Redirecting to home page...');
        setLoading(false);
        window.location.href = '/index';
        // Redirect logic or display unauthorized message
        return;
    }

    let decodedToken ='';
    if (token) {
       decodedToken = (token);
    }
    try {
      //console.log(formData);
      //console.log("formData");
      const response = await fetch(`${api}/book_author/book/${id}`, {
        method: 'delete',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${decodedToken}` // Include token in request header

        },
        body: JSON.stringify({ token: decodedToken }),
      });


      const data = await response.json();
      // setSearchType("")
      setLoading(false);
      navigate('/book');
      window.location.href = '/index';
      //console.log(data);
    } catch (error) {
      //console.log(error);
    }
    setLoading(false);
    setShowForm(false);
    navigate('/book');
  };


  // Define your toolbar options including text alignment
const modules = {
  toolbar: [
    [{ 'header': [1, 2, false] }],
    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
    ['blockquote', 'code-block'],

    [{ 'list': 'ordered'}, { 'list': 'bullet' }],
    [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
    [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
    [{ 'direction': 'rtl' }],                         // text direction
    [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

    [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
    [{ 'font': [] }],
    [{ 'align': [] }],

    ['clean']                                         // remove formatting button
  ],
};

const formats = [
  'header', 'font', 'size',
  'bold', 'italic', 'underline', 'strike', 'blockquote', 'code-block',
  'list', 'bullet', 'indent',
  'link', 'image', 'video',
  'align', 'direction', 'color', 'background'
];
const currentYear = new Date().getFullYear();
  const startYear = 1900;
  const years = Array.from(new Array(currentYear - startYear + 1), (val, index) => startYear + index);
  years.reverse();
 //console.log(book);
 useEffect(() => {

  if (book) {
    const stripHtmlTags = (html) => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      return doc.body.textContent || "";
    };
    const plainTextDescription = stripHtmlTags(book?.description ? book.description.slice(0, 170) : "مجمع الملك سلمان العالمي للغة العربية - المكتبة الرقمية - " + book?.title || "");
    document.querySelector('meta[name="description"]').content = plainTextDescription;
    document.querySelector('meta[name="author"]').content = `${book?.authors}`;
    document.querySelector('link[rel="canonical"]').href = `${window.location.href}`;
  }
} , [book]);

return (
    <>
      <Helmet>
        <title>{book?.title}</title>
        <meta
        name="description"
        content={book && book.description ? book.description.slice(0, 170) : "مجمع الملك سلمان العالمي للغة العربية - المكتبة الرقمية"}
      />
        <meta name="author" content={book?.author} />
        <link rel="canonical" href={`https://library.ksaa.gov.sa/index/${ book?.type === "book" ? "books" : `journal/${book?.category_id}`}/${book?.book_id}`} />
      </Helmet>
    <section className='book-details'>
      <div className='container'>
      <ToastContainer position="top-center" autoClose={5000} hideProgressBar newestOnTop closeOnClick rtl={true} pauseOnFocusLoss draggable pauseOnHover />

        {loading ? (<Loader />     ):(
          <>
      {showForm ? (

          <form className='book-details-form' onSubmit={handleSubmit}>

          <div className='book-details-form-item'>
            <label>النوع <span style={{ color: 'red' }}>*</span></label>
            <select name="type" style={{width:"100%",height:"40px"}} value={formData.type} onChange={handleChange} required>
               <option value="">اختر...</option>
               <option value="book" >كتاب</option>
               <option value="journal">مجلة</option>
            </select>
          </div>
          { formData.type === 'book' && (
             <>
          <div className='book-details-form-item'>
             <label>الكتب أو الاعداد المرتبطة:</label>
             <Autocomplete
            id="book_id"
            options={related_books}
            getOptionLabel={(option) => option.title}
            onChange={(e, newValue) => setFormData({...formData, related_book: newValue})}
            renderInput={(params) => <TextField {...params} />}
          />

           </div>
           { formData.related_book && (
           <div className='book-details-form-item'>
             <label> رقم الجزء / البحث :</label>
             <input type='number' name='order' value={formData.order} onChange={handleChange} />
           </div>
           )}
          </>
           )}

          { formData.type === 'journal' && (

              <div className='book-details-form-item'>

                <label>المجلة <span style={{ color: 'red' }}>*</span></label>
                <select name="category_id" style={{width:"100%",height:"40px"}} value={formData.category_id} onChange={handleChange} required>
  <option value="">اختر...</option>
  {categories.map((category) => {
    return (
      <option key={category.category_id} value={category.category_id}>
        {category.category_name}
      </option>
    );
  })}
</select>

              </div>

              )}
          <div className='book-details-form-item'>
            <label>عنوان <span style={{ color: 'red' }}>*</span></label>
            <input type='text' name='title'  value={formData.title} onChange={handleChange} required/>
          </div>
          <div className='book-details-form-item'>
            <label>وصف:</label>
            <ReactQuill
              style={{
                borderRadius: "7px",
                border: "1px solid"
       }}
    theme="snow"
    value={formData.description}
    onChange={debouncedSetDescription}
    modules={modules}
    formats={formats}
  />
          </div>
          <div className='book-details-form-item'>
            <label> رابط الغلاف <span style={{ color: 'red' }}>*</span></label>
            <input type='text' name='cover_image' value={formData.cover_image} onChange={handleChange} required/>
          </div>
          <div className='book-details-form-item'>
            <label>رابط المحتوى  <span style={{ color: 'red' }}>*</span> </label>
            <input type='text' name='book_url' value={formData.book_url} onChange={handleChange} required/>
          </div>



<div className='book-details-form-item'>
  <label> سنة النشر <span style={{ color: 'red' }}>*</span></label>
  <select

    name='first_publish_year'
    value={formData.first_publish_year}
    onChange={handleChange}
    required  // if the field is mandatory
  >
    <option value="">اختر سنة</option>
    {years.map(year => (
      <option key={year} value={year}>{year}</option>
    ))}
  </select>
</div>
          <div className='form-buttons'>
            <button type='submit'> حفظ  </button>
            <button onClick={confirmDelete}> حذف </button>
            <button type='button' onClick={()=> setShowForm(false)}>إلغاء</button>
          </div>
        </form>

        ) : (
        <>
        <button type='button' style={{color:"#2d5f3a"}} className='flex flex-c back-btn' onClick={() => handleBack()}>
        <FaArrowLeft size={22} style={{ transform: 'rotate(180deg)', marginLeft: '5px' }} />
          <span className='fs-18 fw-6'> السابق</span>
        </button>
        {isLoggedIn?(  <div className='crud-buttons'>
            {!showForm && <button className='update-book-btn' onClick={handleUpdateBook}>تحديث </button>}

          </div>): null }
        <div className='book-details-content grid'>
            <div className='book-details-img'>
              <img style={{
    border: '3px solid #2d5f3a',
    borderRadius:'7px'
}} src = {book?.cover_image} alt = "cover img" />
  {book?.book_url !== "لايوجد رابط" && /^(http:\/\/|https:\/\/)/.test(book?.book_url) ? (
           <Link
           to={`/view/${book.book_id}`}
           state={{ book: book }}
           style={{
            width: '99.8%',
            transform: "translate(0px, -55px)",
            borderTopLeftRadius: '0px',
            borderTopRightRadius: '0px'
         }}
           className="btn-professional">
             اقرأ الآن
         </Link>


  //   <button onClick={() => handleOpenLink(book?.book_url,book.book_id)} className="btn-professional">
  //   إقرا الان
  // </button>
  ) : (
  // Handle the case where book_url is not a valid URL or "لايوجد رابط"
null)}
            </div>

     <div className='book-details-info'>



     <div className='book-details-item title' style={{textAlign:'center'}}>
     <h3 className='fw-6 fs-24'>{book?.title}</h3>
     </div>

     <div className='book-details-container'>
  <div className='book-details-column'>


  {(book.order !== 0 || book.type != "journal") && (
  <div className='book-details-item'>
  <div className="title-wrapper">
    <span className='fw-6'>-</span>
    {book?.authors_comp && book.authors_comp.split(',').length > 1
      ? (
        // Display each author on its own row if there are multiple authors
        <div style={{ display: 'flex', flexDirection: 'column', marginTop: '-3px' }}>
          {book.authors_comp.split(',').map((author, index) => (
            <span key={index} className='text-italic' style={{ margin: '2px 0' }}>{author.trim()}</span>
          ))}
        </div>
      )
      : (
        // Display as is if there is only one author
        <span className='text-italic'>{book?.authors_comp}</span>
      )
    }
  </div>
</div>
  )
  }

    {book?.type === 'journal' &&(
      <div className='book-details-item'>
        <div className="title-wrapper">
          <span className='fw-6'>المجلة :</span>
          <span className='text-italic'>{book?.category}</span>
        </div>
      </div>
    )}
  </div>

  <div className='book-details-column'>
    {/* react js is not number function bult in  */}


    <div className='book-details-item'>
      <div className="title-wrapper">
        <span className='fw-6'> الزيارات :</span>
        <span className='text-italic'>{new Intl.NumberFormat('ar-EG', { useGrouping: false }).format(parseInt(book?.visit))}</span>
      </div>
    </div>


   {book?.first_publish_year && (book?.first_publish_year) !== "لايوجد تاريخ"&&(<div className='book-details-item'>
      <div className="title-wrapper">
        <span className='fw-6'>سنة النشر :</span>
        <span className='text-italic'>
    {new Intl.NumberFormat('ar-EG', { useGrouping: false }).format(parseInt(book?.first_publish_year))}
  </span>
      </div>
    </div>
   )
}
  </div>
</div>
{book?.description && book?.description !== "لايوجد وصف" && (
  <div className='book-details-item description'style={{padding:'20px'}}>

  <ReactQuill
    theme="snow"
    value={book?.description}
    readOnly={true}  // Set ReactQuill to read-only mode
    modules={{ toolbar: false }}  // Optionally disable the toolbar when read-only
  />

  </div>
)}
{book?.related_books && book.related_books.length > 0 &&
      <div className='book-details-item'>
        <div className="title-wrapper" style={{    flexDirection: 'column'
}}>
          <span className='fw-6 fs-24' style={{textAlign:"center"}} >البحوث </span>
          {book.related_books.map((relatedBook) => (
  book.type !== "journal" ? (
    <Link
      key={relatedBook.book_id}
      style={{ width: '100%' }}
      to={`/book/${relatedBook.book_id}`}
      className="btn-professional"
    >
      {relatedBook.title}
    </Link>
  ) : book.type === "journal" ? (
    <>

<div style={{
    display: window.innerWidth > 600 ? "flex" : "block",
    justifyContent: "center",
    alignItems: "baseline"
}}>
      {relatedBook?.author_name && (<p   style={{ flex : 1, alignItems:'right' }} > تأليف: {relatedBook?.author_name} </p>)}

    <Link
      key={relatedBook.article_id}
      style={{ flex : 1,    minHeight: "50px",overflow:"hidden"
      }}
      to={relatedBook.article_url}
      className="btn-professional"
    >
      {relatedBook.article_name}

    </Link>
    </div> </>
  ) : null
))}


        </div>
      </div>
    }




           </div>
         </div>
        </>
        )}
        </>

         )}
    </div>
    </section>
    </>
  )
}



export default BookDetails;
